import {AsyncError} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {Left, map as mapEither, Right} from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {get, post, RequestMethod} from 'Shared/utilities/fetchHelpers';

export type PageFetchActionBase = {
  existingPage: Page<any>;
};

export const removeApiPrefix = (link: string) => link.replace('api/v1/', '');

export const getNextPage = <T>(page: Page<T>) =>
  page.links.filter(link => link.rel === 'nextpage')[0].href.replace('api/v1/', '');

export const mergeWithNextPage = <TData>(pageFetchAction: PageFetchActionBase, requestMethod?: RequestMethod, requestPayload?: any) => {
  let response: Promise<Left<AsyncError> | Right<Page<TData>>>;
  if (requestMethod === RequestMethod.POST) {
    response = post<Page<TData>>((getNextPage(pageFetchAction.existingPage)), requestPayload);
  } else {
    response = get<Page<TData>>(getNextPage(pageFetchAction.existingPage));
  }
  return response.then(pageEither =>
    pipe(
      pageEither,
      mapEither(page => {
        return {
          currentPageNumber: page.currentPageNumber,
          links: page.links,
          result: [...pageFetchAction.existingPage.result, ...page.result],
          totalCount: page.totalCount,
          marketingFormsCategories:
            page.marketingFormsCategories !== undefined ? page.marketingFormsCategories : undefined,
          marketingFormsType: page.marketingFormsType !== undefined ? page.marketingFormsType : undefined,
          interactiveFormsType: page.interactiveFormsType !== undefined ? page.interactiveFormsType : undefined,
          interactiveFormsCategories:
            page.interactiveFormsCategories !== undefined ? page.interactiveFormsCategories : undefined,
        } as Page<TData>;
      })
    )
  );
};
